import React, { RefObject, useEffect, useMemo, useRef, useState } from 'react';
import Table from '../../../components/Table';
import { useBranding } from 'src/branding/BrandingContextProvider';
import {
  calculateTableCharLimit
} from 'src/pages/sharedPageUtils';
import useWindowSize from 'src/hooks/useWindowSize';
import {
  createServiceRequestTableColumns,
  TableColumn,
} from 'src/pages/ServiceRequests/components/helpers';
import FontAwesomeIcon from 'src/components/Icon';
import { useHorizontalScrollChevrons } from 'src/SharedCustomHooks/UseHorizontalScrollChevrons/useHorizontalScrollChevrons';
import '../ServiceRequestDashBoardTable.scss';

interface ServiceRequestDashboardTableProps {
  serviceRequests: any;
  selectedServiceRequests: any;
  onSelectServiceRequest: any;
  onSelectGroup: any;
  onDeleteGroup: any;
  onRemoveFromGroup: any;
  onSelectAll: any;
  allSelected: any;
}

export const ServiceRequestDashboardTable = ({
  serviceRequests,
  selectedServiceRequests,
  onSelectServiceRequest,
  onSelectGroup,
  onDeleteGroup,
  onRemoveFromGroup,
  onSelectAll,
  allSelected,
}: ServiceRequestDashboardTableProps) => {
  const { branding } = useBranding();
  const [expandedGroups, setExpandedGroups] = useState([]);
  const [characterLimit, setCharacterLimit] = useState<number>(80);

  const tableRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const topScrollRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const tableScrollWrapperRef: React.RefObject<HTMLDivElement> =
    useRef<HTMLDivElement>(null);

  const hasTarionNumbers: boolean = useMemo(() => {
    return serviceRequests.some((serviceRequest: any) => {
      if (serviceRequest.isGroup && serviceRequest.children) {
        return serviceRequest.children.some(
          (child: any) => child.tarionItemNumber !== null
        );
      }
      return serviceRequest.tarionItemNumber !== null;
    });
  }, [serviceRequests]);

  const columns: TableColumn[] = useMemo(() => {
    return createServiceRequestTableColumns({
      allSelected,
      onSelectAll,
      expandedGroups,
      setExpandedGroups,
      selectedServiceRequests,
      onSelectGroup,
      onDeleteGroup,
      onSelectServiceRequest,
      onRemoveFromGroup,
      branding,
      hasTarionNumbers,
    });
  }, [
    allSelected,
    expandedGroups,
    selectedServiceRequests,
    branding,
    hasTarionNumbers,
    onSelectAll,
    onSelectGroup,
    onDeleteGroup,
    onSelectServiceRequest,
    onRemoveFromGroup,
  ]);

  const { windowSize } = useWindowSize();

  // Todo: Integrate this with the new JSX below later: WEB-1022 https://app.asana.com/1/41213529744312/task/1211787530791625/comment/1212254369654670?focus=true
  const { showLeftChevron, showRightChevron } = useHorizontalScrollChevrons({
    scrollRef: tableScrollWrapperRef,
    topScrollRef: topScrollRef,
    dependencies: [serviceRequests],
  });

  useEffect(() => {
    const newLimit: number = calculateTableCharLimit(tableRef);

    if (newLimit !== characterLimit) {
      setCharacterLimit(newLimit);
    }
  }, [windowSize]);

  return (
    <div ref={tableRef}>
      <Table
        expandedGroups={expandedGroups}
        applyMinWidth
        defaultSort={{
          accessor: 'createdDate',
          direction: 'ascending',
        }}
        columns={columns}
        data={serviceRequests}
        stickyHeader
        resizeMobileColumns={false}
      />
    </div>
  );
};
